import { env } from "../../env";
var domain;
if (env.REACT_APP_ENV === "development") {
    domain = "http://localhost:3000";
} else if (env.REACT_APP_ENV === "uat") {
    domain = env.REACT_APP_DOMAIN_UAT;
} else {
    domain = env.REACT_APP_DOMAIN_PROD;
}
export { domain };
export var apiUrl = "/api/v1";
export var COMPANY_LOGO = env.REACT_APP_COMPANY_LOGO_URL;
export var YES = "YES";
export var NO = "NO";
export var OK = "OK";
export var TOKEN = "TOKEN";
export var VER = "1.2.14";
export var endPoint = {
    LOGIN_URL: "".concat(apiUrl, "/authpartner/login"),
    REGISTER_URL: "".concat(apiUrl, "/mb-mem"),
    REGISTERSENDMAIL_URL: "".concat(apiUrl, "/mb-mem/confirmemail"),
    REGISTERVERIFY_URL: "".concat(apiUrl, "/mb-mem/confirmemailsuccess"),
    FORGETPASS_URL: "".concat(apiUrl, "/mb-mem/confirmemailrepass"),
    FORGETPASSCHANGE_URL: "".concat(apiUrl, "/mb-mem/resetpassword"),
    VERIFY_ROLE_LOG: "".concat(apiUrl, "/verify-role-log"),
    NEW_ALLDERNOW_USER: "".concat(apiUrl, "/new-alldernow-user"),
    USER_INFO: "".concat(apiUrl, "/new-alldernow-user/get-user-info"),
    MST_PREFIX_URL: "".concat(apiUrl, "/mst-prefix"),
    MST_SEX_URL: "".concat(apiUrl, "/mst-sex"),
    MST_MARITAL_STATUS: "".concat(apiUrl, "/mst-marital-status"),
    MST_MILITARY_STATUS: "".concat(apiUrl, "/mst-military-status"),
    MST_RELATIONSHIP: "".concat(apiUrl, "/mst-relationship"),
    MST_EMPLOYEE_TYPE: "".concat(apiUrl, "/mst-employee-type"),
    MST_DEPARTMENT: "".concat(apiUrl, "/mst-department"),
    MST_POSITION: "".concat(apiUrl, "/mst-position"),
    MST_BANK: "".concat(apiUrl, "/mst-bank"),
    MST_BANK_ACCOUNT_TYPE: "".concat(apiUrl, "/mst-bank-account-type"),
    MST_EMPLOYEE_DOC: "".concat(apiUrl, "/mst-employee-doc"),
    MST_BRANCH: "".concat(apiUrl, "/mst-branch"),
    MST_BUSINESS_TYPE: "".concat(apiUrl, "/mst-business-type"),
    MST_BUSINESS_CATEGORY: "".concat(apiUrl, "/mst-business-category"),
    MST_COMPANY_PREFIX: "".concat(apiUrl, "/mst-company-prefix"),
    MST_PAYMENT_METHOD: "".concat(apiUrl, "/mst-payment-method"),
    MST_PAYMENT_TERM: "".concat(apiUrl, "/mst-payment-term"),
    MST_SUPPLIER_DOC: "".concat(apiUrl, "/mst-supplier-doc"),
    MST_NEW_ALLDERNOW_ROLE: "".concat(apiUrl, "/mst-new-alldernow-role"),
    MST_PAYMENT_TYPE: "".concat(apiUrl, "/mst-payment-type"),
    MST_DISCOUNT_TYPE: "".concat(apiUrl, "/mst-discount-type"),
    MST_PRICE_CATEGORY: "".concat(apiUrl, "/mst-price-category"),
    MST_VAT: "".concat(apiUrl, "/mst-vat"),
    WAREHOUSE: "".concat(apiUrl, "/warehouse"),
    MASTER_BRAND: "".concat(apiUrl, "/get-sys/brand"),
    MASTER_MAIN_CATEGORY: "".concat(apiUrl, "/master-main-category"),
    MST_NEW_ITEM_PR_COL: "".concat(apiUrl, "/mst-new-item-pr-col"),
    MST_OFFICE_SECTION: "".concat(apiUrl, "/mst-office-section"),
    MST_COMPANY: "".concat(apiUrl, "/mst-company/find-first"),
    MST_MART: "".concat(apiUrl, "/mst-mart/find-first"),
    MST_ADD_COST: "".concat(apiUrl, "/mst-add-cost"),
    MST_ADD_COST_UNIT: "".concat(apiUrl, "/mst-add-cost-unit"),
    MST_NEW_ITEM_EXPENSE_COL: "".concat(apiUrl, "/mst-new-item-expense-col"),
    MST_WITHHOLDING_TAX: "".concat(apiUrl, "/mst-withholding-tax"),
    MST_EXPENSE_TYPE: "".concat(apiUrl, "/mst-expense-type"),
    MASTER_PROVICE: "".concat(apiUrl, "/get-sys/province"),
    MASTER_SUPPROVINCE: "".concat(apiUrl, "/get-sys/district"),
    MASTER_DISTRICT: "".concat(apiUrl, "/get-sys/subdistrict"),
    MASTER_DOCUMENT: "".concat(apiUrl, "/get-sys/document"),
    NEW_ALLDERNOW_EMP: "".concat(apiUrl, "/new-alldernow-emp"),
    GROUP_OF_SUPPLIER: "".concat(apiUrl, "/group-of-supplier"),
    SUPPLIER_INFORMATION: "".concat(apiUrl, "/supplier-information"),
    PRODUCT_PRICE: "".concat(apiUrl, "/product-price"),
    NEW_PURCHASE_REQ: "".concat(apiUrl, "/new-purchase-req"),
    NEW_PURCHASE_ORDER: "".concat(apiUrl, "/new-purchase-order"),
    NEW_PO_SPLIT: "".concat(apiUrl, "/new-po-split"),
    NEW_GR: "".concat(apiUrl, "/new-gr"),
    HISTORY_BRANCH_ADDRESS: "".concat(apiUrl, "/history-branch-address"),
    EXPENSE: "".concat(apiUrl, "/expense"),
    GET_MEMBER_INFO: "".concat(apiUrl, "/mb-mem/post-member-info"),
    UPDATE_MEMBER_CHANGEPASSWORD: "".concat(apiUrl, "/mb-mem/changepassword"),
    GETBUSINESS: "".concat(apiUrl, "/bus-business/post-business-info"),
    UPDATE_BUSINESS: "".concat(apiUrl, "/bus-business/updatebusiness"),
    GETBANK: "".concat(apiUrl, "/bus-business/post-businessbank-info"),
    GETDOC: "".concat(apiUrl, "/bus-business/post-businessdoc-info"),
    GET_BUSINESS_COMMENT: "".concat(apiUrl, "/bus-business/post-businesscomment-info"),
    GET_BUSINESS_STATUS: "".concat(apiUrl, "/bus-business/post-business-status"),
    CREATE_COMMENT_BUSINESS: "".concat(apiUrl, "/bus-business/createcomment"),
    UPDATE_COMMENT_BUSINESS: "".concat(apiUrl, "/bus-business/updatecomment"),
    UPDATE_BUSINESS_SENDAPPROVE: "".concat(apiUrl, "/bus-business/updatebusinesssendapprove"),
    MASTER_CHANNEOFFLINE: "".concat(apiUrl, "/get-sys/channeloffline"),
    MASTER_CHANNEONLINE: "".concat(apiUrl, "/get-sys/channelonline"),
    MASTER_UNIT: "".concat(apiUrl, "/get-sys/unit"),
    EVIDENCETYPE: "".concat(apiUrl, "/get-sys/evidencetype"),
    PRODUCTTYPE: "".concat(apiUrl, "/get-sys/producttype"),
    CATEGORY: "".concat(apiUrl, "/get-sys/productcategory"),
    SUBCATEGORY: "".concat(apiUrl, "/get-sys/productcategorysub"),
    MASTER_UNITWEIGHT: "".concat(apiUrl, "/get-sys/unitweight"),
    NEW_PRODUCT: "".concat(apiUrl, "/pd-product/"),
    DATALISTPRODUCT: "".concat(apiUrl, "/pd-product/post-product-info"),
    MASTER_DIMENSION: "".concat(apiUrl, "/get-sys/dimension"),
    DETAILPRODUCT: "".concat(apiUrl, "/pd-product/post-product-detail"),
    UPDATE_PRODUCT: "".concat(apiUrl, "/pd-product/updateproduct"),
    CREATE_COMMENT: "".concat(apiUrl, "/pd-product/createcomment"),
    UPDATE_COMMENT: "".concat(apiUrl, "/pd-product/updatecomment"),
    UPLOAD_PRODUCT: "".concat(apiUrl, "/pd-product/upload_tmp_product"),
    UPLOAD_INFO: "".concat(apiUrl, "/bus-business/upload_tmp_business"),
    CREATE_BANK: "".concat(apiUrl, "/bus-business/createbusinessbank"),
    UPDATE_BANK: "".concat(apiUrl, "/bus-business/updatebusinessbank"),
    DELETE_BANK: "".concat(apiUrl, "/bus-business/deletebusinessbank"),
    CREATE_DOC: "".concat(apiUrl, "/bus-business/createbusinessdoc"),
    UPDATE_DOC: "".concat(apiUrl, "/bus-business/updatebusinessdoc"),
    DELETE_DOC: "".concat(apiUrl, "/bus-business/deletebusinessdoc"),
    MASTER_PRODUCTFILE: "".concat(apiUrl, "/get-sys/productfiletype"),
    BILL: "".concat(apiUrl, "/billing"),
    INVOICE: "".concat(apiUrl, "/invoice"),
    REPORT_PURCHASE_PRODUCT_PO_ITEM: "".concat(apiUrl, "/report-purchase-product-po-item"),
    REPORT_PURCHASE_SUPPLIER: "".concat(apiUrl, "/report-purchase-supplier"),
    REPORT_PURCHASE_ORDER: "".concat(apiUrl, "/report-purchase-order"),
    REPORT_RECEIVE_PRODUCT_GR_ITEM: "".concat(apiUrl, "/report-receive-product-gr-item"),
    PRESENT_INFO: "".concat(apiUrl, "/pd-ppresentation/post-presentation-info"),
    PRESENT_LIST: "".concat(apiUrl, "/pd-ppresentation/list"),
    PRESENT_PORDUCT_LIST: "".concat(apiUrl, "/pd-ppresentation/product-list"),
    PRESENT_CREATE: "".concat(apiUrl, "/pd-ppresentation"),
    PRESENT_UPDATE: "".concat(apiUrl, "/pd-ppresentation/update"),
    ALL_CATALOG: "".concat(apiUrl, "/catalog"),
    GET_GUEST: "".concat(apiUrl, "/get-guest"),
    ALL_SHOP: "".concat(apiUrl, "/get-sys/shop"),
    GET_SHOPBRANCH: "".concat(apiUrl, "/get-sys/shopbranch"),
    MYCART: "".concat(apiUrl, "/catalog/my-cart"),
    ADDCART: "".concat(apiUrl, "/catalog/add-cart"),
    UPDATECART: "".concat(apiUrl, "/catalog/update-cart"),
    DELETECART: "".concat(apiUrl, "/catalog/delete-cart"),
    SUBMITCART: "".concat(apiUrl, "/catalog/submit-cart"),
    BRAND_CATE: "".concat(apiUrl, "/get-sys/brand/catalog"),
    SOCIALCONTACT: "".concat(apiUrl, "/get-sys/socialcontact"),
    SUMMARYCATALOG: "".concat(apiUrl, "/catalog/get-catalog-summary"),
    MYRSERVER: "".concat(apiUrl, "/catalog/myreserver")
};
